export default {
  data() {
    return {
      /**
       * 
       * @type {event: string, callback: Function}[]
       */
      socketListeners: [],
    };
  },
  mounted() {
    this.startSocketListeners();
  },
  destroyed() {
    this.socketListeners.forEach(({event}) => {
      this.sockets.unsubscribe(event);
    });
  },
  methods: {
    startSocketListeners() {
      this.socketListeners.forEach(({event, callback}) => {
        this.sockets.subscribe(event, callback);
      });
    },
  },
}
